<template>
  <section
    class="all-templates-view bg-container-background heightClass overflow-y-auto !rounded-xl"
    id="work-flow-list"
  >
    <el-row type="flex" justify="center" align="center">
      <el-col :span="24">
        <div
          class="inner-navbar !px-3 !py-2 !border-b border-page-border flex items-center justify-between flex-wrap !mb-3 sticky top-0 bg-container-background z-[1] !gap-3"
        >
          <div class="flex items-center !gap-1.5">
            <div class="icon !h-fit" style="fill: var(--brand-500)">
              <icons :iconName="'Templates'"></icons>
            </div>
            <h3
              class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
            >
              Form Builder
            </h3>
          </div>

          <div class="flex items-center !gap-3">
            <el-input
              placeholder="Search"
              prefix-icon="el-icon-search"
              size="small"
              v-model="search_string"
              @input="searchString"
              clearable
              :style="getIsMobile ? 'width:130px' : 'width:170px;'"
            ></el-input>
            <el-button
              v-if="checkPermissionByPermissionsName('addFormBuilder') && getIframeUrlInfo == null"
              class="!text-white !px-4 !py-[7px] !rounded-sm !text-xs 2xl:text-smd !h-fit !border !border-brand-500"
              type="primary"
              @click="goToAddTemplate"
              style="background: var(--brand-500) !important; font-family: var(--font-family)"
            >
              <i class="fa fa-plus-circle"></i>
              {{ getIsMobile ? 'Add new' : 'Add Form Builder' }}
            </el-button>
            <el-tooltip content="Create Iframe link" placement="top">
              <el-link
                class="!px-1.5 !py-1 !bg-white !rounded-sm !border border-black/10 hover:bg-black/10"
                v-if="getIframeUrlInfo == null"
                :underline="false"
                @click="openViewConfigPage"
              >
                <img src="@/assets/img/icons/new/link-icon.svg" alt="" class="!size-4" />
              </el-link>
            </el-tooltip>
          </div>
        </div>

        <div class="vue-data-table-default !pb-0" v-loading="loading">
          <data-tables-server
            v-if="!getIsMobile"
            :data="allWorkflows"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :pagination-props="paginationProps"
            @query-change="loadData"
            style="width: 100%"
          >
            <el-table-column id="name" width="50">
              <template id="category" slot-scope="scope">
                <span v-if="scope.row.icon_type == 'DEFAULT'">
                  <icons :iconName="scope.row.icon ? scope.row.icon : 'Block-Portfolio'"></icons>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Name" min-width="200">
              <template slot-scope="scope">
                <span
                  class="workflow-name"
                  v-on:click="onEdit(scope.row)"
                  style="word-break: break-word"
                >
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="action" width="120">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    Actions
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <a @click="onViewSlots(scope.row)" style="border: none"
                        ><el-dropdown-item
                          icon="el-icon-viewslot-outline"
                          command="viewslot"
                          >View Schedule Slots</el-dropdown-item
                        ></a
                      > -->
                    <!-- <router-link :to="'/fbd/' + scope.row.code">
                        <el-dropdown-item icon="el-icon-view"
                          >View</el-dropdown-item
                        >
                      </router-link> -->

                    <a
                      v-if="IframePermissions('VIEW', 'FormBuilderList')"
                      @click="onView(scope.row)"
                    >
                      <el-dropdown-item icon="el-icon-view">View</el-dropdown-item>
                    </a>
                    <a
                      v-if="getIframeUrlInfo == null"
                      @click="onEdit(scope.row)"
                      style="border: none"
                    >
                      <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                        Edit
                      </el-dropdown-item>
                    </a>
                    <a
                      v-if="IframePermissions('DELETE', 'FormBuilderList')"
                      @click="onDelete(scope.row)"
                      style="border: none"
                    >
                      <el-dropdown-item icon="el-icon-delete" command="delete">
                        Delete
                      </el-dropdown-item>
                    </a>
                    <a
                      v-if="IframePermissions('GET LINK', 'FormBuilderList')"
                      @click="onGetLink(scope.row)"
                    >
                      <el-dropdown-item icon="el-icon-link">Get Link</el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

            <el-table-column label="Filled by" min-width="180">
              <template slot-scope="scope">
                <span class="user-type">{{ getFilledBy(scope.row) || '-' }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Templates / Components" min-width="220" align="center">
              <template slot-scope="scope">
                {{ getTemplateComponentCounts(scope.row.steps) }}
              </template>
            </el-table-column>
            <el-table-column label="Last modified" min-width="200" fixed="right">
              <template slot-scope="scope" v-if="scope.row.updated_at">
                <p class="text-grey-sm mb-0 mt-0">
                  {{ scope.row.updated_at | moment('MM-DD-YYYY') }}
                </p>
                <p class="text-grey-sm mb-0 mt-0">
                  {{ scope.row.updated_at | moment('HH:mm:ss') }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="Created at" min-width="200">
              <template slot-scope="scope" v-if="scope.row.created_at">
                <p class="text-grey-sm mb-0 mt-0">
                  {{ scope.row.created_at | moment('MM-DD-YYYY') }}
                </p>
                <p class="text-grey-sm mb-0 mt-0">
                  {{ scope.row.created_at | moment('HH:mm:ss') }}
                </p>
              </template>
            </el-table-column>
          </data-tables-server>
          <data-tables-server
            :data="allWorkflows"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :pagination-props="paginationProps"
            @query-change="loadData"
            style="width: 100%; height: calc(100vh - 180px)"
            v-else-if="getIsMobile"
            height="calc(100vh - 180px)"
            class="contacts-list-table"
          >
            <el-table-column label="Name" id="name" fixed="left" min-width="200">
              <template slot-scope="scope">
                <span class="workflow-name" v-on:click="onEdit(scope.row)">
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="action" min-width="100">
              <template slot-scope="scope">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    Actions
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <a @click="goToFormbuilder(scope.row)" style="border: none">
                      <el-dropdown-item icon="el-icon-view" command="view">View</el-dropdown-item>
                    </a>
                    <a @click="onEdit(scope.row)" style="border: none">
                      <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                        Edit
                      </el-dropdown-item>
                    </a>
                    <a @click="onDelete(scope.row)" style="border: none">
                      <el-dropdown-item icon="el-icon-delete" command="delete">
                        Delete
                      </el-dropdown-item>
                    </a>
                    <a @click="onGetLink(scope.row)" style="border: none">
                      <el-dropdown-item icon="el-icon-link" command="link">
                        Get Link
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div class="expand-column-item">
                  <div class="expand-column-item-label">Owner:</div>
                  <div
                    class="expand-column-item-content"
                    v-if="scope.row.form_builder_owners.length"
                  >
                    <div v-for="owner in scope.row.form_builder_owners" :key="owner.email">
                      {{ owner.email || '-' }}
                    </div>
                  </div>
                </div>
                <div class="expand-column-item">
                  <div class="expand-column-item-label">Templates / Components</div>
                  <div class="expand-column-item-content">
                    {{ getTemplateComponentCounts(scope.row.steps) }}
                  </div>
                </div>
                <div class="expand-column-item">
                  <div class="expand-column-item-label">Last Modified:</div>
                  <div class="expand-column-item-content">
                    <p class="text-grey-sm mb-0 mt-0">
                      {{ scope.row.updated_at | moment('MM-DD-YYYY') }}
                    </p>
                    <p class="text-grey-sm mb-0 mt-0">
                      {{ scope.row.updated_at | moment('HH:mm:ss') }}
                    </p>
                  </div>
                </div>
                <div class="expand-column-item">
                  <div class="expand-column-item-label">Created at:</div>
                  <div class="expand-column-item-content">
                    <p class="text-grey-sm mb-0 mt-0">
                      {{ scope.row.created_at | moment('MM-DD-YYYY') }}
                    </p>
                    <p class="text-grey-sm mb-0 mt-0">
                      {{ scope.row.created_at | moment('HH:mm:ss') }}
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
          </data-tables-server>
          <div v-else>No Form Builder</div>
        </div>
      </el-col>
    </el-row>
    <dialog-component
      :visible="getLinkPopup"
      @before-close="ClosegetLinkPopup"
      :title="getLinkFormBuilderName"
      :containerWidth="getIsMobile ? '100%' : '35%'"
      :isShowFooter="false"
    >
      <div class="formBuilder-GetLink">
        <h4 class="text-smd xl:!text-mds 2xl:!text-base text-black-950 font-normal !m-1">
          Web link
        </h4>
        <p class="text-xs 2xl:text-smd text-black-950 !mb-4">
          Send a direct link or paste the link in your website
        </p>
        <el-input class="!mb-4" v-model="link" :disabled="true"></el-input>
        <el-button
          style="background: var(--brand-500) !important"
          class="!text-white !px-4 !py-1.5 !border-brand-500 !rounded-md !text-xs 2xl:text-smd !h-fit float-right !mt-2"
          size="mini"
          type="button"
          @click="copyURL"
        >
          <i class="el-icon-copy-document !mr-1"></i>
          Copy Link
        </el-button>
      </div>
    </dialog-component>
    <el-drawer
      title="Privacy Link"
      :visible.sync="copyModal"
      :direction="'rtl'"
      :with-header="true"
      :size="getIsMobile ? '80%' : '25%'"
    >
      <IframeLink :routeKey="url_key" type="FormBuilderList"></IframeLink>
    </el-drawer>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { TimelineLite, Bounce, Elastic } from 'gsap/dist/gsap';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import { fetchFormBuildersByPagination, deleteFormbuilder } from '@/repo/formbuilderDetails';
  import NavigationHelper from '@/mixins/navigationHelper';
  import AccessManagement from '../../mixins/AccessManagement';
  export default {
    components: {
      IframeLink: () => import('../../views/iframeLink.vue'),
    },
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser', 'getActiveWorkspace', 'getUserType']),
      ...mapGetters('formBuilders', [
        // "getAllFormBuildersData",
        'getFormBuilderDeleteStatus',
        'getFormBuilderDeleteError',
        'getFormBuilderPublicURLDetails',
      ]),
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('roles', ['getRoleById', 'getSuccess', 'getRoleErrors']),
      ...mapGetters('iFrame', ['getIframeUrlInfo']),
      ...mapGetters('company', ['getCompanyDetails']),
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [10, 15, 20],
        };
      },
    },
    mixins: [PermissionsHelper, NavigationHelper, AccessManagement],

    async mounted() {
      await this.fetchGroupDetails();
      await this.fetchAllFormBuilders();
      this.timeline = new TimelineLite({
        // onComplete: () => this.timeline.restart()
      });
      // this.animateStatSections();
    },

    data() {
      return {
        hasAccess: true,
        allWorkflows: [],
        currentPage: 1,
        limit: 5,
        pageSize: 10,
        total: 0,
        addBenefitVisible: false,
        updateBenefitVisible: false,
        selectedBenefit: null,
        loading: false,
        search_string: '',
        getLinkPopup: false,
        getLinkFormBuilderName: '',
        link: '',
        copyModal: false,
        url_key: '',
      };
    },
    watch: {
      async '$route.query.group'(group) {
        console.log(group);
        this.fetchAllFormBuilders();
      },
      async '$route.query.key'(key) {
        console.log('key', key);
        this.fetchAllFormBuilders();
      },
      async '$route.params.formbuilder_code'() {
        this.fetchAllFormBuilders();
      },
    },
    methods: {
      formBuilderSettings(item) {
        const items = this.getCompanyDetails?.company_settings?.entity_gridview_settings;
        if (!items) {
          return true;
        }
        return items.includes(item);
      },
      async fetchGroupDetails() {
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.activeRole) {
          await this.$store.dispatch(
            'roles/fetchRoleById',
            this.getAuthenticatedUser.activeRole.role_id
          );
          if (this.$route.query.group && this.$route.query.group.length) {
            await this.$store.dispatch(
              'entityGroups/fetEntityGroupDataById',
              this.$route.query.group
            );
          }
        }
      },
      goToFormbuilder(data) {
        this.$router.push({ path: '/fbd/' + data.code });
      },
      async fetchAllFormBuilders() {
        this.loading = true;
        let params = {
          page: this.currentPage,
          limit: this.pageSize,
        };
        if (this.search_string) {
          params.search_string = this.search_string;
        }
        if (this.$route.query.group && this.$route.query.group.length) {
          params.group = this.$route.query.group;
        }
        if (this.getAuthenticatedUser && this.getAuthenticatedUser.activeRole) {
          if (this.getRoleById && this.getRoleById) {
            params.groups = this.getRoleById.allowed_groups;
          }
        }
        // await this.$store.dispatch("formBuilders/fetchAllFormBuilders", params);
        const getAllFormBuildersData = await fetchFormBuildersByPagination(params);
        this.allWorkflows = [];
        if (getAllFormBuildersData?.data) {
          this.total = getAllFormBuildersData.total;
          this.allWorkflows = getAllFormBuildersData.data;
        }
        this.loading = false;
      },
      ClosegetLinkPopup() {
        this.getLinkPopup = false;
      },
      searchString() {
        this.pageSize = 10;
        this.page = 1;
        this.fetchAllFormBuilders();
      },
      async loadData(data) {
        if ((data && data.type != 'init') || !data) {
          this.pageSize = data.pageSize;
          this.page = data.page;
          await this.fetchAllFormBuilders();
        }
      },

      async refreshFormbuilders() {
        this.pageSize = 10;
        this.currentPage = 1;
        await this.fetchAllFormBuilders();
      },

      async goToAddTemplate() {
        let hasUnlimitedAccess = await this.getAccessToEachFeatureWithUnlimited('form_builder');
        if (hasUnlimitedAccess) {
          this.hasAccess = true;
        } else {
          this.hasAccess = await this.getAccessToEachFeatureWithLimit('number_of_forms');
        }
        if (!this.hasAccess) {
          this.$notify.warning({
            title: 'Access Denied',
            message: 'Forms limit reached.',
            duration: 3000,
          });
          return;
        } else {
          this.$router.push({
            path: '/formBuilders/add',
            query: this.$route.query,
          });
        }
      },
      async onDelete(formbuilder) {
        if (!this.checkAppMode()) {
          return;
        }
        if (
          formbuilder &&
          formbuilder.created_by &&
          this.getAuthenticatedUser &&
          this.getAuthenticatedUser._id &&
          this.getAuthenticatedUser._id != formbuilder.created_by &&
          !this.checkPermissionByPermissionsName('deleteForms')
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for deleting form.Please contact owner.',
          });
        } else {
          this.$confirm('Are you sure to delete the Form builder?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.deleteFormbuilder(formbuilder);
          });
        }
      },
      async deleteFormbuilder(formbuilder) {
        try {
          await this.$store.dispatch('formBuilders/deleteFormbuilder', formbuilder._id);
          if (this.getFormBuilderDeleteStatus) {
            await deleteFormbuilder(formbuilder._id);
            this.$notify.success({
              title: 'Success',
              message: 'Form builder deleted successfully',
            });
            this.refreshFormbuilders();
          } else {
            let message =
              this.getFormBuilderDeleteError && this.getFormBuilderDeleteError.message
                ? this.getFormBuilderDeleteError.message
                : 'Some went wrong on delete workflow';
            this.$notify.error({
              title: 'Error',
              message: message,
            });
          }
        } catch (error) {
          console.error('deleteFormbuilder', error);
        }
      },
      onView(form_builder_id) {
        if (!this.checkPermissionByPermissionsName('viewForms')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for viewing form.Please contact owner.',
          });
        } else {
          let UrlPathAdd = '';
          if (this.getIframeUrlInfo != null) {
            UrlPathAdd = `/if/${this.getIframeUrlInfo._id}/fbd/${form_builder_id.code}`;
          } else {
            UrlPathAdd = `/fbd/${form_builder_id.code}`;
          }
          this.$router.push({
            path: UrlPathAdd,
            query: this.$route.query,
          });
        }
      },
      onEdit(form_builder_id) {
        if (!this.checkAppMode()) {
          return;
        }
        if (this.getIframeUrlInfo == null) {
          if (
            form_builder_id &&
            form_builder_id.created_by &&
            this.getAuthenticatedUser &&
            this.getAuthenticatedUser._id &&
            this.getAuthenticatedUser._id != form_builder_id.created_by &&
            !this.checkPermissionByPermissionsName('editForms')
          ) {
            this.$notify.error({
              title: 'Error',
              message: 'Permission denied for editing form.Please contact owner.',
            });
          } else {
            this.$router.push({
              name: 'EditFormBuilders',
              params: { form_builder_id: form_builder_id._id },
              query: this.$route.query,
            });
          }
        }
      },

      onViewSlots(workflow) {
        this.$router.push({
          name: 'ScheduleSlots',
          query: {
            workflow_id: workflow._id,
          },
        });
      },
      async onGetLink(formBuilder) {
        this.loading = true;
        if (formBuilder?.customization?.show_link_to_be_copy) {
          await this.$store.dispatch('formBuilders/fetchWorkFlowPublicURL', {
            formbuilder_details_id: formBuilder._id,
          });
          if (this.getFormBuilderPublicURLDetails.public_url) {
            this.getLinkFormBuilderName = formBuilder.name;
            this.link = this.getFormBuilderPublicURLDetails.public_url;
            this.loading = false;
            this.getLinkPopup = true;
          }
        } else {
          this.$message.error('You do not have permission to get link');
          this.loading = false;
        }
      },
      copyURL() {
        navigator.clipboard.writeText(this.link);
        this.$message({
          message: 'Link copied successfully!',
          type: 'success',
        });
      },
      getFilledBy(row) {
        if (row.form_builders_owner === 'ENTITY') {
          return 'Application users';
        } else if (row.form_builders_owner === 'USER') {
          return 'Company users';
        } else if (row.form_builders_owner === 'COMPANY') {
          return 'Anyone';
        } else {
          return 'Anonymous';
        }
      },
      getTemplateComponentCounts(steps) {
        let templates = 0;
        let documents = 0;
        steps.forEach((element) => {
          if (element && element.type) {
            if (element.type == 'COMPANY_DOCUMENTS' || element.type == 'OFFER_LETTER') {
              documents = documents + 1;
            } else {
              templates = templates + 1;
            }
          }
        });
        return templates + ' / ' + documents;
      },

      animateStatSections() {
        const {
          statOne,
          statOneIcon,
          statOneContent,
          statTwo,
          statTwoIcon,
          statTwoContent,
          statThree,
          statThreeIcon,
          statThreeContent,
        } = this.$refs;

        // this.timeline.to([statOne, statTwo, statThree], 0, {
        //   autoAlpha:0
        // })

        this.timeline
          .from(statOne, 1.5, {
            autoAlpha: 0,
            scale: 1.25,
            ease: Bounce.easeOut,
          })
          .from(
            statOneContent,
            1.5,
            {
              autoAlpha: 0,
              scale: 0,
              ease: Elastic.easeInOut,
            },
            '-=1.5'
          )
          .from(
            statOneIcon,
            1.5,
            {
              opacity: 0,
              scale: 1.25,
              ease: Bounce.easeInOut,
            },
            '-=1'
          );

        this.timeline
          .from(
            statTwo,
            1.5,
            {
              autoAlpha: 0,
              scale: 1.25,
              ease: Bounce.easeOut,
            },
            '-=1'
          )
          .from(
            statTwoContent,
            1.5,
            {
              autoAlpha: 0,
              scale: 0,
              ease: Elastic.easeInOut,
            },
            '-=1.5'
          )
          .from(
            statTwoIcon,
            1.5,
            {
              opacity: 0,
              scale: 1.25,
              ease: Bounce.easeInOut,
            },
            '-=1'
          );

        this.timeline
          .from(
            statThree,
            1.5,
            {
              autoAlpha: 0,
              scale: 1.25,
              ease: Bounce.easeOut,
            },
            '-=1'
          )
          .from(
            statThreeContent,
            1.5,
            {
              autoAlpha: 0,
              scale: 0,
              ease: Elastic.easeInOut,
            },
            '-=1.5'
          )
          .from(
            statThreeIcon,
            1.5,
            {
              opacity: 0,
              scale: 1.25,
              ease: Bounce.easeInOut,
            },
            '-=1'
          );
      },
      openViewConfigPage() {
        ((this.url_key = this.$route.fullPath), (this.copyModal = true));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-button--primary.is-plain {
    color: var(--brand-500);
    background: var(--brand-500);
    border-color: var(--brand-500);

    &:hover {
      color: var(--primary-contrast-color);
      background: var(--brand-500);
      border-color: var(--brand-500);
    }
  }

  .formBuilder-GetLink {
    // margin: 0px 0px 20px 0px;
  }

  .workflow-name {
    cursor: pointer;
  }

  .workflows-list {
    width: 90%;
    display: table;
    margin: 0 auto;

    .guide-stats-block {
      padding: 1em 0 2em;

      .each-stat {
        position: relative;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 1em 1em 0.75em;
        color: #ffffff;
        overflow: hidden;
        min-height: 105px;

        &.stat-one {
          background-color: #ff83a1;
        }

        &.stat-two {
          background-color: #5673dc;
        }

        &.stat-three {
          background-color: #ffbd12;
        }

        .icon {
          position: relative;
          z-index: 3;

          img {
            max-height: 50px;
          }
        }

        .cover {
          position: absolute;
          left: 0;
          right: 0;
          bottom: -10px;
          z-index: 1;

          img {
            width: 100%;
          }
        }

        .stat-content {
          position: relative;
          z-index: 2;
        }

        h3 {
          font-size: 3em;
          font-weight: 300;
          line-height: 1;
          text-align: center;
        }

        p {
          position: absolute;
          text-align: right;
          bottom: 0;
          right: 0;
        }
      }

      .usage-guide {
        position: relative;
        min-height: 105px;
        display: flex;
        background-color: #ebf0f3;
        border-radius: 8px;
        padding: 1em 1em 0.75em;
        overflow: hidden;

        .content {
          position: relative;
          z-index: 2;
        }

        .icon-right {
          width: 200px;
          position: relative;
          z-index: 3;
        }

        h4 {
          font-size: 1em;
          margin: 0;
          font-weight: 400;
        }

        p {
          font-size: 0.75em;
          line-height: 1.3;
          margin: 0.25em 0 0.75em;
        }

        .el-button {
          font-size: 0.85em;
          padding: 0.35em 0.75em;
          background-color: #6979f8;

          &:hover {
            background-color: #4558e9;
          }
        }

        .cover {
          position: absolute;
          left: 0;
          right: 0;
          bottom: -10px;
          z-index: 1;

          img {
            width: 100%;
          }
        }
      }
    }
  }

  .contacts-list-table {
    .action-buttons {
      display: flex;
      flex-direction: row !important;

      & > li {
        margin-right: 0px !important;
        margin-left: 0px !important;

        & > button {
          margin-right: 3px !important;
          margin-left: 0px !important;
        }
      }

      .first-button {
      }

      .second-button {
      }

      .third-button {
      }
    }
  }

  .top-buttons-wrapper {
    @media (max-width: 991.98px) {
      display: flex;
      margin-top: 20px;
    }
  }

  .user-type {
    color: #3366cc;
  }

  el-button__primary:hover {
    color: var(--primary-contrast-color);
    background-color: var(--brand-500);
    border-color: var(--brand-500);
  }

  .create-btn {
    height: 32px;
  }

  .inner-navbar .left-block .icon-block {
    display: flex !important;
    align-items: center;
    gap: 10px !important;

    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
</style>
